import React from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';

import Button from '../../components/UI/Button';

import styles from './EditBurnRate.module.css';
import { CurrencyEnum } from '../../types/enums';
import { AppState } from '../../store';
import { setBurnRate } from '../../store/actions/burnRateActions';

interface EditBurnRateProps {
  onSubmit?: Function;
}

interface BurnRateFormData {
  amount: number;
  currency: CurrencyEnum;
}

const AddAccount: React.FC<EditBurnRateProps> = ({ onSubmit }) => {
  const burnRate = useSelector((state: AppState) => state.burnRate);
  const defaultValues = burnRate || {
    amount: undefined,
    currency: undefined,
  };

  const { register, handleSubmit } = useForm<BurnRateFormData>({
    defaultValues,
  });
  const dispatch = useDispatch();

  const submit = ({ amount, currency }: BurnRateFormData) => {
    dispatch(setBurnRate(amount, currency));
  };

  return (
    <form
      className={styles.container}
      onSubmit={handleSubmit((data) => {
        submit(data);
        onSubmit && onSubmit();
      })}
    >
      <h2>{burnRate ? 'Edit' : 'Add'} your burn rate</h2>
      <p>
        Approximate your monthly expenses in a currency of your choice.
        <br />
        We won’t be holding your hand during these calculations or
        <br />
        preaching to stop having coffees at Starbucks. We are all adults,
        <br />
        after all.
      </p>
      <input
        type="number"
        name="amount"
        placeholder="Amount"
        ref={register}
        className={styles.field}
      />
      <select name="currency" required ref={register} className={styles.field}>
        <option value="" selected disabled hidden>
          Currency
        </option>
        <option value={CurrencyEnum.USD}>USD</option>
        <option value={CurrencyEnum.EUR}>EUR</option>
        <option value={CurrencyEnum.UAH}>UAH</option>
      </select>
      <Button submit value="Save" className={styles.submit} />
    </form>
  );
};

export default AddAccount;
